import React from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsAppFloatingButton = () => {
  return (
    <a
      href="https://wa.me/919967933888"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: 100,
        right: 24,
        zIndex: 9999,
        backgroundColor: '#fcc000',
        borderRadius: '50%',
        padding: '10px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <WhatsAppIcon style={{ color: 'white', fontSize: 32 }} />
    </a>
  );
};

export default WhatsAppFloatingButton;